import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { normalizeResultsResponse } from "features/results/utils/normalizeResultsResponse";

const DEFAULT_LIMIT = 20;

const buildUrl = ({
  tenantVal,
  patientId,
  orderBy,
  searchQuery,
  unreviewed,
  limit,
  offset,
}) => {
  const params = new URLSearchParams();

  if (orderBy) params.set("orderBy", orderBy);
  // Server-side pagination: BE returns this page + a `totalCount`.
  params.set("limit", String(limit));
  params.set("offset", String(offset));
  if (searchQuery) params.set("searchQuery", searchQuery);
  if (unreviewed !== undefined) params.set("unreviewed", String(unreviewed));

  return `${tenantVal}/healthlink/laboratory/results/${patientId}?${params.toString()}`;
};

export const usePatientLaboratoryResults = ({
  orderBy,
  patientId,
  searchQuery,
  unreviewed,
  limit = DEFAULT_LIMIT,
  offset = 0,
  enabled = true,
}) => {

  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: [
      "patientLaboratoryResults",
      orderBy,
      searchQuery,
      unreviewed,
      limit,
      offset,
      tenantVal,
      patientId,
    ],
    queryFn: async () => {
      const axiosInstance = await createAxiosInstance();
      const response = await axiosInstance.get(
        buildUrl({
          tenantVal,
          patientId,
          orderBy,
          searchQuery,
          unreviewed,
          limit,
          offset,
        })
      );

      return normalizeResultsResponse(response.data);
    },
    meta: { errorMessage: "Error fetching patient laboratory results" },
   
    staleTime: 1000,
    enabled: enabled && !!patientId && !!tenantVal,
  });
};
